<template>
  <div class="holacon_home" id="init">

    <HomeMenu />

    <div class="page-content">
      <div class="content-wrapper">
        <vue-page-transition name="fade">
          <router-view></router-view>
        </vue-page-transition>
      </div>
    </div>

  </div>
</template>

<script>
import HomeMenu from "@/components/HomeMenu";

export default {
  name: "Init",
  components: { HomeMenu },
};
</script>

<style lang="less">

#header {
  position: fixed;
  width: 100%;
  background: white;
  z-index: 4;
  box-shadow: 0px 0px 6px rgba(0,0,0,0.2);
}
</style>



// WEBPACK FOOTER //
// src/pages/Init.vue